import { RoundId } from '@vote4dance/judging-types';
import { RoundItem } from '../models/rounds';

export function groupRoundListIntoChildren(rounds: RoundItem[]) {
    const groupedRounds: RoundItem[] = [];
    
    if (rounds) {
        let previousRoundParentId: string | null = null;
        let firstRoundToMove: RoundItem | null = null;
        let numberOfSequentialMatches = 0;

        const parentRounds = rounds.filter(round => round.round_children > 0);
        
        const validRounds = rounds.filter(round => round.round_type != 'skating' && round.round_children == 0 && !round.isPlaceholder);

        const groupChildRounds = (firstRoundToMove: RoundItem, numberOfSequentialMatches: number) => {
            const moveIndex = groupedRounds.indexOf(firstRoundToMove);
            // Move all found to placeholder parent
            let lookupParentRound = parentRounds.find(a => a.round_id == firstRoundToMove.round_parent_id);
            if(!lookupParentRound) {
                lookupParentRound = { ...firstRoundToMove };
                lookupParentRound.round_id = lookupParentRound.round_parent_id;
                lookupParentRound.round_label = lookupParentRound.round_parent_label;
                lookupParentRound.round_parent_label = '';
                lookupParentRound.round_parent_id = '0' as RoundId;
            }
            
            const round = { ...lookupParentRound };
            round.rowKey = round.round_id + '-' + moveIndex as RoundId;
            round.isPlaceholder = true;
            round.children = groupedRounds
                .splice(moveIndex, numberOfSequentialMatches)
                .map(child => ({
                    ...child,
                    isGroupedInSchedule: true
                }));
            if(round.children) {
                round.round_judges_done = round.children.every(child => child.round_judges_done > 0) ? 1 : 0;
            }
            groupedRounds.push(round);
        }

        validRounds.forEach((round, index) => {
            // Reset round children
            round.children = undefined;
            round.rowKey = round.round_id;

            // Check for child round
            if (RoundItem.isChildRound(round)) {

                // Set first round to move
                if (firstRoundToMove == null) {
                    firstRoundToMove = round;

                }

                // Check if parents match
                if (previousRoundParentId == null || previousRoundParentId === round.round_parent_id) {

                    // Add to move list
                    numberOfSequentialMatches++;

                } else {
                    if (numberOfSequentialMatches > 1) {
                        groupChildRounds(firstRoundToMove!, numberOfSequentialMatches)
                    }

                    // Restart move list
                    firstRoundToMove = round;
                    numberOfSequentialMatches = 1;
                }

                // Store round parent id
                previousRoundParentId = round.round_parent_id;

            } else {

                if (numberOfSequentialMatches > 1) {
                    groupChildRounds(firstRoundToMove!, numberOfSequentialMatches)
                }

                // Reset move list
                numberOfSequentialMatches = 0;
                previousRoundParentId = null;
                firstRoundToMove = null;

            }

            groupedRounds.push(round);

            // Check if we are on last round
            if(numberOfSequentialMatches > 1 && index === validRounds.length -1) {
                groupChildRounds(firstRoundToMove!, numberOfSequentialMatches)
            }
        })
    }
    return groupedRounds;
}